<template>

	<div class="knd-language-toggle" @click="toggle">
		<div class="knd-language-highlight" :class="toggleVal.toLowerCase()"></div>
		<div class="knd-taal">
			<slot name="left"></slot>
		</div> 
		<div class="knd-taal twee">
			<slot name="right"></slot>
		</div>
	</div>
</template>


<script>

	export default {
		name: 'Toggle',
		props: {
			value: {
				type: String,
				default: 'LEFT'
			},
			toggleFn:Function
		},
		data() {
			return {
				toggleVal: this.value
			};
		},
		methods: {
			toggle() {
				this.toggleVal = this.toggleVal === 'LEFT' ? 'RIGHT' : 'LEFT';
				this.toggleFn(this.toggleVal);
			}
		}
	}
</script>

<style lang="scss">
 .knd-language-toggle {
    width: 100px;
    height: 50px;
    border-radius: 25px;
    background-color: #ffcad1;
    cursor: pointer;
    color: #fff;
    position: relative;

    .knd-taal {
        position: absolute;
        width: 25px;
        top: 10px;
        left: 15px;
    }

    .knd-taal.twee {
        left: auto;
        right: 12px;
    }

    .knd-language-highlight {
      width: 50px;
      height: 50px;
      background-color: #ff5362;
      border-radius: 25px;
      position: absolute;
      top: 0;
      left: 0;
      -webkit-animation-duration: .2s;
      animation-duration: .2s;
      -webkit-animation-timing-function: ease;
      animation-timing-function: ease;

      &.left {
         animation-name: toLeft;
         left: 0;
     }

     &.right {
      animation-name: toRight;
      left: 50px;
     }
  }

  @keyframes toLeft {
    0% {
        left: 50px
    }

    to {
        left: 0
    }
}

@keyframes toRight {
    0% {
        left: 0
    }

    to {
        left: 50px
    }
}


}

</style>